<div class="beneficiary-form" [formGroup]="form">
  <div class="beneficiary-form__grid">
    <!-- Nombre (firstName) -->
    <div class="beneficiary-form__field">
      <ui-molecule-input
        textId="firstName"
        formControlName="firstName"
        [label]="'beneficiaries.form.firstName.label' | translate"
        [placeholder]="'beneficiaries.form.firstName.placeholder' | translate"
        [required]="true"
        [maxLength]="limits.firstNameMax"
        [errorMessage]="firstNameError"
      >
      </ui-molecule-input>
    </div>

    <!-- Apellidos (lastName) -->
    <div class="beneficiary-form__field">
      <ui-molecule-input
        textId="lastName"
        formControlName="lastName"
        [label]="'beneficiaries.form.lastName.label' | translate"
        [placeholder]="'beneficiaries.form.lastName.placeholder' | translate"
        [required]="true"
        [maxLength]="limits.lastNameMax"
        [errorMessage]="lastNameError"
      >
      </ui-molecule-input>
    </div>

    <!-- Email -->
    <div class="beneficiary-form__field">
      <ui-molecule-input
        textId="email"
        formControlName="email"
        type="email"
        autocomplete="email"
        [label]="'beneficiaries.form.email.label' | translate"
        [placeholder]="'beneficiaries.form.email.placeholder' | translate"
        [required]="true"
        [maxLength]="limits.emailMax"
        [errorMessage]="emailError"
      >
      </ui-molecule-input>
    </div>

    <!-- Teléfono -->
    <div class="beneficiary-form__field">
      <label class="beneficiary-form__label"
        >{{ 'beneficiaries.form.phone.label' | translate }} *</label
      >
      <ui-atom-phone-input
        formControlName="phone"
        placeholder="{{ 'beneficiaries.form.phone.placeholder' | translate }}"
        [required]="true"
      >
      </ui-atom-phone-input>
      @if (phoneError) {
        <p class="beneficiary-form__error-text" role="alert">{{ phoneError }}</p>
      }
    </div>

    <!-- Fecha de Nacimiento -->
    <div class="beneficiary-form__field">
      <ui-molecule-input
        textId="birthDate"
        type="date"
        formControlName="birthDate"
        [label]="'beneficiaries.form.birthDate.label' | translate"
        [placeholder]="'beneficiaries.form.birthDate.placeholder' | translate"
        [required]="true"
        [maxAttr]="todayISO"
        [errorMessage]="birthDateError"
      >
      </ui-molecule-input>
    </div>

    <!-- País de Nacimiento -->
    <div class="beneficiary-form__field">
      <label class="beneficiary-form__label">
        {{ 'beneficiaries.form.birthCountry.label' | translate }} *
      </label>
      <ui-atom-country-select
        formControlName="birthCountry"
        [placeholder]="'beneficiaries.form.birthCountry.placeholder' | translate"
        [required]="true"
      >
      </ui-atom-country-select>
      @if (
        (birthCountryControl?.touched || submitted) && birthCountryControl?.hasError('required')
      ) {
        <p class="beneficiary-form__error-text" role="alert">
          {{ 'beneficiaries.form.birthCountry.error.required' | translate }}
        </p>
      }
    </div>

    <!-- Género -->
    <div class="beneficiary-form__field">
      <label class="beneficiary-form__label">
        {{ 'beneficiaries.form.gender.label' | translate }} *
      </label>
      <select formControlName="gender" class="beneficiary-form__select">
        <option value="">
          {{ 'beneficiaries.form.gender.placeholder' | translate }}
        </option>
        @for (option of genderOptions; track option.value) {
          <option [value]="option.value">{{ option.labelKey | translate }}</option>
        }
      </select>
      @if ((genderControl?.touched || submitted) && genderControl?.hasError('required')) {
        <p class="beneficiary-form__error-text" role="alert">
          {{ 'beneficiaries.form.gender.error.required' | translate }}
        </p>
      }
    </div>

    <!-- País de Acogida -->
    <div class="beneficiary-form__field">
      <label class="beneficiary-form__label">
        {{ 'beneficiaries.form.hostCountry.label' | translate }} *
      </label>
      <ui-atom-country-select
        formControlName="hostCountry"
        [placeholder]="'beneficiaries.form.hostCountry.placeholder' | translate"
        [required]="true"
      >
      </ui-atom-country-select>
      @if ((hostCountryControl?.touched || submitted) && hostCountryControl?.hasError('required')) {
        <p class="beneficiary-form__error-text" role="alert">
          {{ 'beneficiaries.form.hostCountry.error.required' | translate }}
        </p>
      }
    </div>

    <!-- External ID -->
    <div class="beneficiary-form__field">
      <ui-molecule-input
        textId="externalId"
        formControlName="externalId"
        [label]="'beneficiaries.form.externalId.label' | translate"
        [placeholder]="'beneficiaries.form.externalId.placeholder' | translate"
        [maxLength]="limits.externalIdMax"
        [errorMessage]="externalIdError"
      >
      </ui-molecule-input>
    </div>

    <!-- GDPR Consent (solo en creación) -->
    @if (mode === 'create') {
      <div class="beneficiary-form__field beneficiary-form__field--full">
        <ui-atom-checkbox
          textId="gdpr-consent"
          formControlName="gdprConsent"
          [isRequired]="true"
          [labelText]="'beneficiaries.form.gdprConsent.label' | translate"
        ></ui-atom-checkbox>
        @if ((gdprConsentControl?.touched || submitted) && gdprConsentControl?.hasError('required')) {
          <p class="beneficiary-form__error-text" role="alert">
            {{ 'beneficiaries.form.gdprConsent.error.required' | translate }}
          </p>
        }
      </div>
    }
  </div>
</div>
